export { useSheetStore } from "@/lib/store/Sheets";
export type { SheetInstance } from "@/lib/store/Sheets";

export const SheetContentType = {
	JOB: "job",
	PATIENT: "patient",
	SEARCH: "search",
	FORM: "form",
	JOB_REQUEST: "job_request",
	QUICKSTART: "quickstart",
	ARTICLE: "article",
	MATERIAL_TRACEABILITY: "material_traceability",
} as const;
